import Core from '@mediaplatform/sportal365-multisport-sdk';
import { useMemo } from 'react';
import { multisport } from '../api';
import initSmpMultisportSDK from '../lib/SmpMultisportSDK';

import { IUseMultisportApi, MutlisportSdkOptions as mutlisportOptions } from '../types';

export const getMultisportApi = (sdkMultisport: Core): IUseMultisportApi => {
  return {
    $multisport: multisport(sdkMultisport),
  };
};

// Plain function to use outside React components
export const initMultisportApi = (sdkOptions: mutlisportOptions) => {
  const sdkMultisport = initSmpMultisportSDK(sdkOptions);

  return getMultisportApi(sdkMultisport);
};

// React hook to use inside React components
export default function useMultisportApi(sdkOptions: mutlisportOptions) {
  const sdkMultisport = useMemo(() => initSmpMultisportSDK(sdkOptions), [sdkOptions]);

  return useMemo(() => getMultisportApi(sdkMultisport), [sdkMultisport]);
}
